<template>
  <v-card>
    <v-card-text>
      Upload de fichiers
      <div class="files">
        <template v-for="(file,i) in files">
          <template v-if="file">
            <file-upload :key="file.id" v-model="files[i]" @uploaded="uploadFile" />
          </template>
        </template>
        <file-upload v-model="files[files.length]" @uploaded="uploadFile" />
      </div>

      <v-btn
        v-if="order.status=='paid' && files.length > 0"
        @click.stop="confirm()"
      >Confirmer la commande</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import FileUpload from "../FileUpload.vue";
export default {
  components: {
    FileUpload
  },
  data: function() {
    return {
      files: this.order.files ? this.order.files : []
    };
  },
  props: {
    order: {
      type: Object,
      require: true
    }
  },
  methods: {
    confirm() {
      this.$store.dispatch("order/confirm", this.order.id).then(() => {
        this.$emit("update");
      });
    },

    uploadFile() {
      this.$store
        .dispatch("order/upload", { orderId: this.order.id, files: this.files })
        .then(() => {
          this.$emit("update");
        });
    }
  }
};
</script>

<style>
</style>